import classes from './tooltip.module.css'

const Tooltip = {
  defaultProps: {
    transitionProps: {
      transition: 'pop',
      duration: 200,
      timingFunction: 'ease-in-out',
    },
  },
  classNames: {
    tooltip: classes.tooltip,
  },
}

export default Tooltip
